import { Component, Input } from '@angular/core';
import { Loadable } from '@app/components/pr-loader/ILoadable';
import { PrCard, PrCardType } from '../pr-card/pr-card.component';

@Component({
    selector: 'pr-cards',
    templateUrl: './pr-cards.component.html',
    styleUrls: ['./pr-cards.component.scss'],
    standalone: false
})
export class PrCardsComponent extends Loadable {
  @Input() cards: PrCard[];
  @Input() vertical: boolean = false;
  @Input() fill: boolean = false;
  @Input() clazz: string = 'mbxl';
  PrCardType = PrCardType;

  constructor() {
    super();
  }

  get class() {
    if (this.vertical) return 'vertical';
    else if (this.cards && this.cards.length >= 5)
      return `grid grid-col-5 grid-col-md-2 grid-col-sm-1 ${this.clazz}`;
    else if (this.cards && this.cards.length >= 4)
      return `grid grid-col-4 grid-col-md-2 grid-col-sm-1 ${this.clazz}`;
    else if (this.cards && this.cards.length >= 3)
      return `grid grid-col-3 grid-col-sm-2 grid-col-xs-1 ${this.clazz}`;
    else return `grid grid-col-2 grid-col-xs-1 ${this.clazz}`;
  }
}
